import(/* webpackMode: "eager" */ "/tmp/8deed7838a42f69/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8deed7838a42f69/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8deed7838a42f69/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8deed7838a42f69/src/components/Header.tsx");
